import React, { useRef } from 'react';
import { dayTheme, fills, insideOutsideFills } from './themes';
import { Box } from '@mui/material';
import { BeatLoader } from 'react-spinners';
import { GroupBy } from '../../types';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { BarchartObject, ChartTheme } from './interfaces';
import { barChartOptions } from './chartOptions';
import highchartsAccessibility from 'highcharts/modules/accessibility';

interface BarChartProps {
  barchartData: BarchartObject | null;
  groupBy: GroupBy;
  isLoading: boolean;
  showTemperature: boolean;
  temperatureData: number[];
}

export const BarChart = ({ barchartData, groupBy, isLoading, showTemperature, temperatureData }: BarChartProps) => {
  const container = useRef<HighchartsReact.RefObject>(null);

  const myTheme: ChartTheme = {
    ...dayTheme,
    displayText: `Energy Usage Grouped by ${groupBy}`,
    fillColors: groupBy === 'Tags' ? fills : insideOutsideFills,
  };

  highchartsAccessibility(Highcharts);

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1,
          }}
        >
          <BeatLoader color={myTheme.fillColors[0]} />
        </Box>
      )}

      <HighchartsReact
        highcharts={Highcharts}
        options={barChartOptions(
          barchartData ?? { categories: [], series: [] },
          myTheme,
          showTemperature,
          temperatureData
        )}
        ref={container}
      />
    </Box>
  );
};
